/**
 * ScrollButton Module
 * helper class
 */
export default class {
  /**
   * constructor
   */
  constructor() {
    this.body = document.body;
    this.document = document.documentElement;
    this.scrollButton = document.querySelector('[data-scroll-button]');

    if (this.scrollButton) {
      document.addEventListener('scroll', () => this.readPosition());

      this.scrollButton.addEventListener('click', () => this.topFunction());
    }
  }

  /**
   * Read readPosition
   * @desc shows/hides scrollbutton
   *   read scroll position
   */
  readPosition() {
    if (this.body.scrollTop > 200 || this.document.scrollTop > 200) {
      this.scrollButton.style.display = 'block';
    } else {
      this.scrollButton.style.display = 'none';
    }
  }

  /**
   * topFunction
   * @desc scrolls back to top
   *   scrolls back to top
   */
  topFunction() {
    this.body.scrollTop = 0; // For Safari
    this.document.scrollTop = 0; // For Chrome, Firefox, IE and Opera
  }
}
